<script>
  import ContainerTypeTabs from "@retailer/svelte/ListBuilder/Components/ProductPicker/ContainerTypeTabs.svelte";
  import Icon from "@shared/svelte/Components/Icon.svelte";
  export let list;
  export let placeholderProduct;
  export let showBackButton;
  export let onGoBackToProductLineResults;
  export let onAddProductToList;
  export let onRemoveProductFromList;
  export let onProductPickerTabChange;
  export let onAddAnotherProduct;
  export let picker;
  $: {
    list = list;
    picker = picker;
  }
</script>

<div>
  <header
    class="list-builder__product-header default-subheader--regular default-title--regular--sm"
  >
    {#if showBackButton}
      <Icon
        extraClassNames="cursor-pointer margin-right--smaller"
        type="ArrowLeft"
        onPress={onGoBackToProductLineResults}
        height="24"
        width="24"
      />
    {/if}
    <span class="notranslate">{picker.productLine.name}</span>
  </header>
  {#if !picker.isLoadingProductLineDetails}
    <ContainerTypeTabs
      {...picker}
      {list}
      {placeholderProduct}
      {onAddProductToList}
      {onRemoveProductFromList}
      {onProductPickerTabChange}
    />
    <footer class="align-center margin--medium">
      <button
        on:click|preventDefault={() => onAddAnotherProduct()}
        class="button button--primary margin-bottom--medium"
      >
        Add Another Product
      </button>
    </footer>
  {/if}
</div>
